const searchControlStyle = {
  root: {
    padding: "10px",
  },
};

export default searchControlStyle;
